import { cn, LoadingSpinner } from '@moreharvest/component-library';

const modalWrapperClasses = cn(
    'fixed inset-0 w-screen h-screen flex justify-center items-center z-[10000]'
);

const modalClasses = 'w-32 flex flex-col relative';

const LoadingModal = ({ bw = false }: { bw?: boolean }) => {
    return (
        <div
            className={cn(
                modalWrapperClasses,
                'bg-neutral-50 dark:bg-neutral-50-dark'
            )}
        >
            <div className={modalClasses}>
                <LoadingSpinner bw={bw} />
            </div>
        </div>
    );
};

export default LoadingModal;
